const routes = [{
  path: '/ultimate/embranchment',
  component: () => import('@/views/ultimate/embranchment/index'),
  name: 'ultimate-embranchment',
  meta: {
    title: '分支管理'
  }
}, {
  path: '/ultimate/embranchment/organizationDetails',
  component: () => import('@/views/ultimate/embranchment/organizationDetails'),
  name: 'embranchment-details',
  meta: {
    title: '查看机构详情'
  }
}, {
  path: '/ultimate/embranchment/task',
  component: () => import('@/views/ultimate/embranchment/components/task'),
  name: 'embranchment-task',
  meta: {
    title: '人员导出列表'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/ultimate/embranchment.js